import { NgModule } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MyCustomPaginatorIntl } from 'app/core/services/paginator_service/my-paginator.service';
import { SharedModule } from 'app/shared/shared.module';
import { LineItemPickerComponent } from './line-item-picker.component';

@NgModule({
  declarations: [
    LineItemPickerComponent
  ],
  imports: [
    SharedModule
  ],
  exports: [
    LineItemPickerComponent
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: MyCustomPaginatorIntl },
    { provide: MAT_DIALOG_DATA, useValue: {} }, { provide: MatDialogRef, useValue: {} }
  ]
})
export class LineItemPickerModule { }
